import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutsComponent } from './../shared/layouts/layouts.component';
import { LeadsComponent } from './Leads/Leads.component';
import { AssignedComponent } from './assigned/assigned.component';
import { CreateLeadComponent } from './create-lead/create-lead.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ChartComponentComponent } from './chart-component/chart-component.component';
import { LeadBulkUploadComponent } from './lead-bulk-upload/lead-bulk-upload.component';
import { FollowUpListComponent } from './follow-up-list/follow-up-list.component';
import { LostJunkListComponent } from './lost-junk-list/lost-junk-list.component';
import { AuthGuard } from '../auth/guard/auth.guard';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { NotificationListDetailsComponent } from './notification-list-details/notification-list-details.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SearchLeadComponent } from './search-lead/search-lead.component';
import { UsersComponent } from './users/users.component';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { NonSalesListComponent } from './non-sales-list/non-sales-list.component';
import { EmailSettingsComponent } from './email-settings/email-settings.component';
const routes: Routes = [
  {
    path: '',
    component: LayoutsComponent,
    children: [
      { path: 'leads', component: LeadsComponent, canActivate:[AuthGuard] },
      { path: 'assigned', component: AssignedComponent, canActivate:[AuthGuard] },
      { path: 'create-lead', component: CreateLeadComponent, canActivate:[AuthGuard] },
      { path: 'user-profile', component: UserProfileComponent, canActivate:[AuthGuard] },
      { path: 'overview', component: ChartComponentComponent, canActivate:[AuthGuard] },
      { path: 'lead-upload', component: LeadBulkUploadComponent, canActivate:[AuthGuard] },
      { path: 'follow-up', component: FollowUpListComponent, canActivate:[AuthGuard] },
      { path: 'junk', component: LostJunkListComponent, canActivate:[AuthGuard] },
      { path: 'change-password', component: ChangePasswordComponent, canActivate:[AuthGuard] },
      { path: 'to-do', component: NotificationListDetailsComponent, canActivate:[AuthGuard] },
      { path: 'search-lead', component: SearchLeadComponent, canActivate:[AuthGuard] },
      { path: 'users', component: UsersComponent, canActivate:[AuthGuard] },
      { path: 'user-guide', component: UserGuideComponent, canActivate:[AuthGuard] },
      { path: 'non-sales', component: NonSalesListComponent, canActivate:[AuthGuard] },
      { path: 'email-settings', component: EmailSettingsComponent, canActivate:[AuthGuard] },
      {
        path: '**', pathMatch: 'full',
        component: PageNotFoundComponent, canActivate: [AuthGuard]
      },
    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
